import Vue from 'vue';
import Vuex from 'vuex';

import baseinfo from '@/store/baseinfo/store';
import brandAudit from '@/store/brand-audit/store';
import brandStore from '@/store/brand-store/store';
import common from '@/store/common/store';
import data from '@/store/data/store';
import design from '@/store/design/store';
import digital from '@/store/digital/store';
import digitalAsset from '@/store/digital-asset/store';
import digitalFur from '@/store/digital-fur/store';
import digitalRoom from '@/store/digital-room/store';
import finance from '@/store/finance/store';
import home from '@/store/home/store';
import login from '@/store/login/store';
import materials from '@/store/materials/store';
import message from '@/store/message/store';
import meta from '@/store/meta/store';
import organization from '@/store/organization/store';
import profile from '@/store/profile/store';
import statistics from '@/store/statistics/store';
import system from '@/store/system/store';
import tool from '@/store/tool/store';
import ue from '@/store/ue/store';
import website from '@/store/website/store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    baseinfo,
    brandAudit,
    brandStore,
    common,
    data,
    design,
    digital,
    digitalAsset,
    digitalFur,
    digitalRoom,
    finance,
    home,
    login,
    materials,
    message,
    meta,
    organization,
    profile,
    statistics,
    system,
    tool,
    ue,
    website,
  },
});
